import { render } from "./App.vue?vue&type=template&id=e8c86120"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e8c86120&lang=css"

import exportComponent from "/Users/alejandromillan/Documents/Projects/wrwlf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__